import { createContext, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";

export const DataContext = createContext();

function AppLayout({ children = <></> }) {
  const [isVariant, setVariant] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  // ✅ REMOVED isLoading state entirely — it was causing CLS

  return (
    <DataContext.Provider value={{ setVariant, setActiveIndex, 
      setLoading: () => {} // ✅ keep API intact so other pages don't break
    }}>
      <Header activeIndex={activeIndex} isVariant={isVariant} />
      <MiddleData data={children} />
      <Footer />
    </DataContext.Provider>
  );
}

function MiddleData({ data }) {
  return data;
}

export default AppLayout;